define('module/fade',[
    'jquery',
    'underscore',
    'cnf'
], function($,_,Cnf) {
    'use strict';
    
    return function()
    {
        this.options={
            delay:3.5,
            selector:{
                trigger:'.trigger-fade',
                item:'.fade-item'
            },
            data:{
                active:'active',
                zindex:'zindex'
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initFade();
        };
        
        this.initOptions=function()
        {
            this.oFade={};
            this.$fade=Cnf.$app.find(this.options.selector.trigger);
            this.iFade=this.$fade.length;
        };
        
        this.initFade=function()
        {
            if(this.iFade<=0) {
                return;
            }
            
            var $item;
            
            for(var i=0;i<this.iFade;i++) {
                $item=this.$fade.eq(i).find(this.options.selector.item);
                
                this.oFade[i]={
                    current:0,
                    $item:$item,
                    length:$item.length
                };
                this.triggerFade(i);
            }
        };
        
        this.triggerFade=function(index)
        {
            window.setInterval(_.bind(this.fadeNext,this,index), (this.options.delay *1000));
        };
        
        this.fadeNext=function(index)
        {
            //A) 2 slides
            if(this.oFade[index].length===2) {
                //hide the other item
                var iCurrent=(this.oFade[index].current===0) ? 0 : 1;
                this.oFade[index].$item.eq(iCurrent).attr('data-' + this.options.data.zindex, 'false');
                _.delay(_.bind(function(index, iCurrent) {
                    this.oFade[index].$item.eq(iCurrent).attr('data-' + this.options.data.active, 'false');
                },this, index, iCurrent), ((this.options.delay *1000) -300));
                
            //B) more than 2 slides
            } else {
                //hide previous
                var iPrev=this.oFade[index].current -1;
                if(iPrev<0) {
                    iPrev=this.oFade[index].length -1;
                }
                this.oFade[index].$item.eq(iPrev).attr('data-' + this.options.data.active, 'false');

                //reset zindex of current
                this.oFade[index].$item.eq(this.oFade[index].current).attr('data-' + this.options.data.zindex, 'false');
            }
            
            //show next
            var iNext=this.oFade[index].current +1;
            if(iNext>=this.oFade[index].length) {
                iNext=0;
            }
            this.oFade[index].$item.eq(iNext).attr('data-' + this.options.data.zindex, 'true')
                    .attr('data-' + this.options.data.active, 'true');
            
            this.oFade[index].current++;
            if(this.oFade[index].current>=this.oFade[index].length) {
                this.oFade[index].current=0;
            }
        };
        
        this.init();
    };
});
